import React from 'react';

import { CHECK_LABELS } from './adapters';

// step 2 of a money-moving action; one payment operator, so the dialog asks twice.
const ConfirmStep = ({ id, action, needs, summary, warn, input, on_input, error, check_label }) => (
  <div className="tp-po-confirm" role="group" aria-label="Confirm">
    {summary.map((s) => (
      <div
        key={s}
        className={warn ? 'tp-banner tp-banner-warn' : 'tp-banner'}
        role={warn ? 'alert' : undefined}
      >
        {s}
      </div>
    ))}
    {needs.amount ? (
      <div className="tp-field">
        <label htmlFor={`${id}-amount`}>Type the amount to confirm (₹)</label>
        <input
          id={`${id}-amount`}
          className="tp-input"
          inputMode="decimal"
          autoComplete="off"
          value={input.amount}
          onChange={(e) => on_input({ ...input, amount: e.target.value })}
          placeholder="24840.00"
        />
      </div>
    ) : null}
    {needs.checked ? (
      <label htmlFor={`${id}-check`} className="tp-po-check">
        <input
          id={`${id}-check`}
          type="checkbox"
          checked={input.checked === true}
          onChange={(e) => on_input({ ...input, checked: e.target.checked })}
        />{' '}
        {check_label || CHECK_LABELS[action]}
      </label>
    ) : null}
    {error ? (
      <span className="tp-neg" role="alert">
        {error}
      </span>
    ) : null}
  </div>
);

export default ConfirmStep;
